export default {
  root: {
    class: ['mb-0', 'border-b border-surface-200 dark:border-surface-700'],
  },
};
